<svelte:options accessors={true}/>

<style>
  :global(*) {
    -moz-box-sizing:border-box; -webkit-box-sizing:border-box; box-sizing:border-box;
  }

  .WebApplication {
    display:inline-block; position:relative; overflow:visible;
    border:none; border-radius:2px; margin:0px; padding:0px;
    background:white;

    font-family:'Source Sans Pro','Helvetica Neue',Helvetica,Arial,sans-serif;
    font-size:14px; font-weight:400; color:black;
    line-height:150%;
  }
</style>

<script context="module" lang="ts">
  import { value_is_string } from '../ValueClassifications.js'
</script>

<script lang="ts">
  $: class_names = [
    'WebApplication',
    value_is_string($$restProps.class) ? $$restProps.class : ''
  ].join(' ')
</script>

<div {...$$restProps} class={class_names}>
  <slot></slot>
</div>
